// extracted by mini-css-extract-plugin
export var lbContainerOuter = "B_tM";
export var lbContainerInner = "B_tN";
export var movingForwards = "B_tP";
export var movingForwardsOther = "B_tQ";
export var movingBackwards = "B_tR";
export var movingBackwardsOther = "B_tS";
export var lbImage = "B_tT";
export var lbOtherImage = "B_tV";
export var prevButton = "B_tW";
export var nextButton = "B_tX";
export var closing = "B_tY";
export var appear = "B_tZ";